import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/home";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 5500);
    return () => window.clearInterval(timer);
  }, [total]);

  const goTo = (next: number) => setIndex((next + total) % total);
  const active = heroSlides[index];

  return (
    <section
      className="group relative w-full overflow-hidden rounded-lg bg-primary-950"
      aria-label="焦点内容轮播"
    >
      <div className="relative h-[420px] w-full md:h-[540px]">
        {heroSlides.map((slide, i) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
            aria-hidden={i !== index}
          >
            <img
              src={slide.image}
              alt={`${slide.title} 焦点图`}
              title={`${slide.title} 焦点推荐 巨乳娱乐资讯网`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-primary-950/20"></div>
          </div>
        ))}

        <div className="absolute inset-x-0 bottom-0 w-full p-6 md:p-10">
          <div className="max-w-2xl">
            <span className="inline-block rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
              {active.label}
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-4xl">
              {active.title}
            </h2>
            <p className="mt-2 line-clamp-2 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
              {active.subtitle}
            </p>
            <Link
              to={active.link}
              className="mt-5 inline-flex whitespace-nowrap items-center gap-1 rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              查看详情
              <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => goTo(index - 1)}
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/40 text-background-50 transition-colors hover:bg-primary-950/70 md:flex md:left-6 cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => goTo(index + 1)}
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-primary-950/40 text-background-50 transition-colors hover:bg-primary-950/70 md:flex md:right-6 cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl" aria-hidden="true"></i>
        </button>

        <div className="absolute bottom-6 right-6 flex items-center gap-2">
          {heroSlides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第 ${i + 1} 张`}
              onClick={() => goTo(i)}
              className={`h-2 rounded-full transition-all cursor-pointer ${
                i === index ? "w-6 bg-accent-500" : "w-2 bg-background-100/60"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}